module.exports = __webpack_public_path__ + "img/icon_patent_es.212167b0.png";